import React, { useContext, useEffect, useState } from "react";
import styles from "../../styles/profileInfo.module.css";
import profileManuImg from "../../assets/images/profile/profile.svg";
import loginpasswordImg from "../../assets/images/profile/login-password.svg";
import apimanagementImg from "../../assets/images/profile/api_management.svg";
import safetyImg from "../../assets/images/profile/safety.svg";
import securityImg from "../../assets/images/profile/security.svg";
import { GetTokenApi, PostTokenApi } from "../../api/api-service";
import { API_Path } from "../../const";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { errorContainer, formAttr } from "../common/CommonFun";
import SecurityInfo from "./SecurityInfo";
import SafetyPhraseInfo from "./SafetyPhraseInfo";
import { AuthContext } from "../../context/AuthContext";
import LoginPasswordInfo from "./LoginPasswordInfo";
import ApimanagementInfo from "./ApimanagementInfo";

var dataOFPersonal = "";
var kycData = 0;

export default function ProfileInfo() {
    const navigate = useNavigate();

    const [useKycDetailsData, setUserKycDetailsData] = useState({ ...dataOFPersonal });
    const [loading, setLoading] = useState(false);
    const [kycStep, setKycStep] = useState(kycData);
    const [verifyCode, setVerifyCode] = useState();
    const [securityGoogleAuthShow, setSecurityGoogleAuthShow] = useState(false);
    const [securityFlag, setSecurityFlag] = useState("google");
    const [safetyPhraseBtn, setSafetyPhraseBtn] = useState({
        showModal: false,
        safetyFlag: "email",
    });
    const [changePassShow, setChangePassShow] = useState(false);
    const [APIManagementShow, setAPIManagementShow] = useState(false);
    const { userCurrentData } = useContext(AuthContext);

    useEffect(() => {
        getUserKYCProfile();
    }, []);

    const handleShowSecurityModal = (flag) => {
        setSecurityGoogleAuthShow(true);
        setSecurityFlag(flag);
    };
    const handleShowSafetyPhraseBtn = (flag) => {
        setSafetyPhraseBtn({
            showModal: true,
            safetyFlag: flag,
        });
    };

    const getUserKYCProfile = () => {
        setLoading(true);
        const getCryptoCurrency = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.getUserKycProfile));
        });
        getCryptoCurrency.then((res) => {
            setLoading(false);
            if (res) {
                dataOFPersonal = res.data;
                if (dataOFPersonal.Id > 0) kycData = 2;
                else kycData = 1;
                setKycStep(kycData);
                setUserKycDetailsData(dataOFPersonal);
            } else toast.error("Something went wrong!");
        });
    };

    const handleEditProfile = () => setKycStep(1);
    const handleRedirect = () => navigate("/useraccount/profile/user-kyc-info");

    return (
        <React.Fragment>
            <div className={styles.personal_info_box}>
                <div className={styles.title}>
                    <h6>Account Verification</h6>
                </div>
                <div className={styles.profile_info_body}>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className={`${styles.profile_info} card`}>
                                <div className={styles.icon}>
                                    <img src={profileManuImg} alt="" className="img-fluid" />
                                </div>
                                <div className="flex-1">
                                    <h4>Personal Info</h4>
                                    <b></b>
                                </div>
                                <div className={styles.info_data_button}>
                                    <button type="submit" className={styles.button} onClick={handleRedirect}>
                                        My Info
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className={`${styles.profile_info} card`}>
                                <div className={styles.icon}>
                                    <img src={securityImg} alt="" className="img-fluid" />
                                </div>
                                <div className="flex-1">
                                    <h4>Security</h4>
                                    <b></b>
                                </div>
                                <div className={styles.info_data_button}>
                                    <button className={styles.button} onClick={() => handleShowSecurityModal("google")}>
                                        Google Auth
                                    </button>
                                    <button className={`ms-3 ${styles.button}`} onClick={() => handleShowSecurityModal("mobile")}>
                                        Mobile Auth
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className={`${styles.profile_info} card`}>
                                <div className={styles.icon}>
                                    <img src={safetyImg} alt="" className="img-fluid" />
                                </div>
                                <div className="flex-1">
                                    <h4>Safety Phrase</h4>
                                    <b></b>
                                </div>
                                <div className={styles.info_data_button}>
                                    <button className={styles.button} onClick={() => handleShowSafetyPhraseBtn("email")}>
                                        E-mail
                                    </button>
                                    <button className={`ms-3 ${styles.button}`} onClick={() => handleShowSafetyPhraseBtn("login")}>
                                        Log in
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className={`${styles.profile_info} card`}>
                                <div className={styles.icon}>
                                    <img src={apimanagementImg} alt="" className="img-fluid" />
                                </div>
                                <div className="flex-1">
                                    <h4>API Management</h4>
                                    <b></b>
                                </div>
                                <div className={styles.info_data_button}>
                                    <button className={styles.button} onClick={() => setAPIManagementShow(true)}>
                                        Create
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className={`${styles.profile_info} card`}>
                                <div className={styles.icon}>
                                    <img src={loginpasswordImg} alt="" className="img-fluid" />
                                </div>
                                <div className="flex-1">
                                    <h4>Login Password</h4>
                                    <b></b>
                                </div>
                                <div className={styles.info_data_button}>
                                    <button className={styles.button} onClick={() => setChangePassShow(true)}>
                                        Change
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ----------------------------------------- CHANGE PASSWORD ----------------------------------------- */}
            <LoginPasswordInfo showModal={changePassShow} handleClose={() => setChangePassShow(false)} />
            {/* ----------------------------------------- CHANGE PASSWORD ----------------------------------------- */}

            {/* ----------------------------------- SECURITY INFO --------------------------------------- */}
            <SecurityInfo googleAuthShow={securityGoogleAuthShow} handleClose={() => setSecurityGoogleAuthShow(false)} securityFlag={securityFlag} />
            {/* ----------------------------------- SECURITY INFO --------------------------------------- */}

            {/* ----------------------------------- API MANAGEMENT INFO --------------------------------------- */}
            <ApimanagementInfo show={APIManagementShow} handleClose={() => setAPIManagementShow(false)} />
            {/* ----------------------------------- API MANAGEMENT INFO --------------------------------------- */}

            {/* -------------------------------------  SAFETY PHRASE INFO ------------------------------------ */}
            <SafetyPhraseInfo
                show={safetyPhraseBtn.showModal}
                handleClose={() => setSafetyPhraseBtn({ ...safetyPhraseBtn, showModal: false })}
                safetyFlag={safetyPhraseBtn.safetyFlag}
                EmailSafetyCode={userCurrentData?.EmailSafetyCode}
                LoginSafetyCode={userCurrentData?.LoginSafetyCode}
            />
            {/* -------------------------------------  SAFETY PHRASE INFO ------------------------------------ */}
        </React.Fragment>
    );
}
